import { render, staticRenderFns } from "./vrForm.vue?vue&type=template&id=6dac31bf"
import script from "./vrForm.vue?vue&type=script&lang=js"
export * from "./vrForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports